import { RoleRuName } from '@/constants/user'

export const getRoleName = (role:string) => {
    return RoleRuName[role as keyof typeof RoleRuName] || ''
}